import { UploadCloud } from "lucide-react";
import { Card } from "../../ui";
import { Label } from "./shared";

export function LoteUploadCard({ associados, commonBoletoType, commonDescription, commonTitle, onFilesPicked, sendEmail, setCommonBoletoType, setCommonDescription, setCommonTitle, setSendEmail }) {
  return (
    <>
      <Card className="p-5 mb-5">
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <Label>Título comum (opcional)</Label>
            <input
              data-testid="lote-common-title"
              value={commonTitle}
              onChange={(e) => setCommonTitle(e.target.value)}
              placeholder="Ex.: Boleto Julho/2026"
              className="mt-1 w-full border border-slate-300 px-3 py-2.5 rounded-sm"
            />
            <p className="text-[11px] text-slate-500 mt-1">
              Aplicado a todos: <em>“{commonTitle || "…"} — Nome do Associado”</em>. Deixe em branco para usar o nome do arquivo.
            </p>
          </div>
          <div>
            <Label>Descrição comum (opcional)</Label>
            <input
              data-testid="lote-common-description"
              value={commonDescription}
              onChange={(e) => setCommonDescription(e.target.value)}
              placeholder="Ex.: Mensalidade referente a Julho/2026"
              className="mt-1 w-full border border-slate-300 px-3 py-2.5 rounded-sm"
            />
          </div>
          <div>
            <Label>Tipo (aplicado a todo o lote)</Label>
            <select
              data-testid="lote-common-boleto-type"
              value={commonBoletoType}
              onChange={(e) => setCommonBoletoType(e.target.value)}
              className="mt-1 w-full border border-slate-300 px-3 py-2.5 rounded-sm bg-white"
            >
              <option>Mensalidade</option>
              <option>Anuidade</option>
              <option>Taxa Extra</option>
              <option>Multa</option>
              <option>Outro</option>
            </select>
          </div>
        </div>

        <div className="mt-4 flex items-center gap-2">
          <input
            data-testid="lote-send-email"
            id="lote-send-email"
            type="checkbox"
            checked={sendEmail}
            onChange={(e) => setSendEmail(e.target.checked)}
            className="h-4 w-4 accent-[#002776]"
          />
          <label
            htmlFor="lote-send-email"
            className="text-sm text-slate-700 cursor-pointer select-none"
          >
            Enviar e-mail de notificação aos associados
            <span className="text-slate-500">
              {" "}
              (aplicado a todos os boletos deste lote)
            </span>
          </label>
        </div>

        <div className="mt-5">
          <label
            data-testid="lote-picker"
            className="flex flex-col items-center justify-center border-2 border-dashed border-slate-300 hover:border-[#002776] hover:bg-slate-50 rounded-sm px-6 py-8 cursor-pointer transition-colors"
          >
            <UploadCloud size={26} className="text-slate-500" strokeWidth={1.4} />
            <div className="mt-2 text-sm font-medium">
              Selecionar arquivos de boleto (múltiplos PDFs)
            </div>
            <div className="text-xs text-slate-500 mt-1">
              Até 25 MB por arquivo. Clique ou arraste arquivos aqui.
            </div>
            <input
              type="file"
              multiple
              accept="application/pdf,image/*"
              onChange={onFilesPicked}
              className="hidden"
            />
          </label>
        </div>
      </Card>

    </>
  );
}
